import { ITurnedTextStyle } from "../../../../documaker/domain/format/objects";
import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";

export interface ITurnedTextStylePropertyEditable {
  turnedTextStyle(): IPropertyEditable<ITurnedTextStyle>;
}

export function instanceOfITurnedTextStylePropertyEditable(instance: any): instance is ITurnedTextStylePropertyEditable {
  return instance
      && instance.turnedTextStyle
      && instanceOfIPropertyEditable<ITurnedTextStyle>(instance.turnedTextStyle());
}
